/**
 * Describes the source of the identifier that RelatedPositionID(1862) represents.
 * tag: 1863
 * @readonly
 * @enum {number} (int)
 */
export enum RelatedPositionIDSource {
  /** Position maintenance report ID - PosMaintRptID(721) */
  PosMaintRptID = 1,
  /** Position transfer ID - TransferID(2437) */
  TransferID = 2,
  /** Position entity ID - PositionID(2618) */
  PositionEntityID = 3,
}
